<template>
  <div class="main">
    <div class="d-flex full-width-image">
      <form class="form-signin" v-on:submit.prevent="do_login">
        <h1 class="h4 mb-1 font-weight-normal text-center">{{$t('login_connect_to_invoxia')}}</h1>
        <p class="h6 m-2 mb-3 font-weight-normal text-center">{{$t('professional_platform')}}</p>

        <label for="inputEmail" class="sr-only">Email address</label>
        <input v-model="username" type="email" id="inputEmail" class="form-control" :placeholder="$t('login_email')"
               required
               autofocus>
        <div v-if="advanced">
          <label for="inputAdmin" class="sr-only">Admin email</label>
          <input v-model="admin" type="email" id="inputAdmin" class="form-control" placeholder="admin email" required>
        </div>
        <label for="inputPassword" class="sr-only">Password</label>
        <input v-model="password" type="password" id="inputPassword" class="form-control"
               :placeholder="$t('login_password')"
               required>
        <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="submitted">{{$t('login_signin')}}
        </button>
        <div class="mt-4 mb-2 text-center">
          <a :href="password_reset_url">{{$t('login_reset_password')}}</a>
          <h5 class="bg-light text-danger" v-if="error===402">{{$t('invalid_account_error')}}</h5>
          <h5 class="bg-light text-danger" v-else-if="error">{{$t('login_error')}}</h5>

          <p class="mt-2 text-muted">&copy; 2017-{{ currentYear }}</p>

        </div>
      </form>
    </div>
  </div>

</template>

<script>
import {HTTP} from '../http-constants'
import {baseURL} from '../http-constants'

export default {
  name: 'Login',
  data() {
    return {
      'username': null,
      'password': null,
      'admin': null,
      'advanced': true,
      'next_route': null,
      'error': null,
      'submitted': false,
      'password_reset_url': '/password_reset',
      currentYear: new Date().getFullYear(),
    }
  },
  methods: {
    do_login: function () {
      var self = this;
      this.submitted = true;
      console.log("submitted");
      let login_data = {email: this.username, password: this.password};
      if (this.admin) {
        login_data.admin = self.admin;
      }
      HTTP.post(this.$store.state.endpoints.obtainJWT, login_data)
          .then(response => {
            let data = response.data;
            self.$store.commit('updateToken', data.token)
            HTTP.defaults.headers.common['Authorization'] = "Bearer " + data.token
            if (response.status === 200) {
              this.error = null;
              self.get_account_state();
            }
          })
          .catch(e => {
            console.log("error", e);
            this.submitted = false
            if (e.response && e.response.status === 402) {
              console.log("status", e.response.status);
              this.error = e.response.status;
            } else {
              this.error = e;
            }
          });
    },
    get_account_state: function () {
      let self = this;
      HTTP.get('/options/')
          .then(response => {
            let data = response.data;
            let account_state = data.account_state;
            if (account_state == 'delinquent') {
              self.$router.push('/user/invoices/');
            } else if (self.next_route) {
              self.$router.push({name: self.next_route});
            } else {
              self.$router.push('/user');
            }
          })
          .catch(e => {

          })
    }
  },
  mounted: function () {
    let self = this;
    this.password_reset_url = baseURL + '/password_reset'

    let parameters = this.$route.query;
    this.advanced = parameters['advanced'];
    this.next_route = parameters['next']

    if (parameters['token']) {
      let token = parameters['token'];
      self.$store.commit('updateToken', token)
      HTTP.defaults.headers.common['Authorization'] = "Bearer " + token;
      self.get_account_state();
    }
  }
}
</script>

<style scoped>

.full-width-image {
  height: 100%;
  width: 100%;

  background-image: url("/images/background-road.jpg") !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

</style>